// import { shoptourApi } from 'yxt-biz-pc/packages/api';
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
// 拼接URL参数
const linkSubString = (url, data) => {
  if (url === null || url === '') {
    return url;
  }
  let queryString = '';
  if (typeof data === 'object') {
    for (var i in data) {
      queryString += i + '=' + data[i] + '&';
    }
  }
  if (url.indexOf('?') > url.indexOf('/')) {
    url += '&';
  } else {
    url += '?';
  }
  if (queryString !== '') {
    queryString = queryString.substr(0, queryString.length - 1);
  }
  url += queryString;
  return url;
};

// 查询区域树
export const getAreaList = (id) => {
  return apiBaseUrl.get('/si/statement/area-tree', { params: { id } });
};

// 获取门店列表-选门店组件使用
export const getStoreSearchList = (data) => {
  return apiBaseUrl.get(linkSubString('/si/statement/store-list', data));
};

// 获取门店分类列表
export const getCateList = (params) => {
  const url = linkSubString('/si/statement/storecatalog-list', params);
  return apiBaseUrl.get(url);
};
